import React from 'react';
import { cn } from '../../utils/cn';

export default function Button({ children, variant = 'primary', className, ...props }) {
  const baseStyles = "inline-flex items-center justify-center px-8 py-4 text-sm tracking-wide transition-all duration-300 font-medium";
  
  const variants = {
    primary: "bg-brand-terra text-brand-cream hover:bg-opacity-90 hover:scale-[1.02]",
    secondary: "border border-brand-cream text-brand-cream hover:bg-brand-cream hover:text-brand-deep",
    dark: "bg-brand-deep text-brand-cream hover:bg-brand-olive",
    outlineDark: "border border-brand-deep text-brand-deep hover:bg-brand-deep hover:text-brand-cream"
  };

  return (
    <button className={cn(baseStyles, variants[variant], className)} {...props}>
      {children}
    </button>
  );
}